import DocumentImage from './document-image';

export default DocumentImage;